import { replacer } from "./nameFormatter";

export default function genFieldNomenclature({
  fieldSuffixArr,
  fieldName,
  rowFieldCount
}) {
  const encodedName = replacer(fieldName);
  const fieldSuffix = fieldSuffixArr[rowFieldCount % fieldSuffixArr.length];
  const poolFieldName = encodedName + fieldSuffix;
  return {
    poolName: encodedName,
    fieldSuffix,
    poolFieldName
  };
}
